import React from "react";
import { useSelector } from "react-redux";
import WidgetCarouselCard from "../../features/widget/widgetCarouselCard/WidgetCarouselCard";
import pathRouts from "../../../enums/pathRoute";
import usefulToolsImg from "../../../../assests/carouselWidget/useFullTolls.png";

const UsefulToolsCarouselWidget = () => {

    const { texts } = useSelector(state => state.translate);

    return (
        <WidgetCarouselCard
            color="#4A4A4A"
            titleColor="#fff"
            title={texts.myTools}
            image={usefulToolsImg}
            imageAlt={texts.myTools}
            link={`/${pathRouts.USEFULTOOLS}`}
        />
    );
};

export default UsefulToolsCarouselWidget;
